// Editor-wide UI constants: zoom bounds/steps and page-size presets.

export const MIN_SCALE = 0.25;
export const MAX_SCALE = 4;
export const ZOOM_STEPS = [0.25, 0.35, 0.5, 0.65, 0.8, 1, 1.25, 1.5, 2, 2.5, 3, 4];

export const MM_TO_PT = 72 / 25.4;

/** How long a mixed selection's arrow-key nudges accumulate before one
 *  move is committed. Each one rewrites the page in the wasm worker, so
 *  a held key must not become a burst of rebases — the frame previews
 *  the pending offset in the meantime. */
export const NUDGE_FLUSH_MS = 450;

export const PAGE_PRESETS: Record<string, [number, number]> = {
  A4: [595.28, 841.89],
  A5: [419.53, 595.28],
  Letter: [612, 792],
  Legal: [612, 1008],
  Tabloid: [792, 1224],
};

export const MARGIN_QUICK: readonly [string, number][] = [
  ["None", 0],
  ["Slim", 10],
  ["Normal", 20],
  ["Wide", 30],
];

/** PDF points → display unit (1 pt = 1/72 inch exactly, so measurements
 *  are physically true without calibration; the measure tool's factor
 *  handles drawings at scale). */
export function ptToUnit(pt: number, unit: "pt" | "mm" | "cm" | "in"): number {
  switch (unit) {
    case "pt":
      return pt;
    case "mm":
      return (pt * 25.4) / 72;
    case "cm":
      return (pt * 2.54) / 72;
    case "in":
      return pt / 72;
  }
}
